"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { sendWebEvent } from "~/lib/webevents/WebEventsClient";
import { sendGtmEvent } from "~/lib/gtm/gE";
import { useUnauthorizedEventService } from "~/services/api/services/event";
import { useLogEvent } from "~/hooks/useLogEvent";

const ClientApiScript = () => {
    const logEvent = useLogEvent();
    const sendBigQueryEvent = useUnauthorizedEventService();
    const router = useRouter();

    useEffect(() => {
        window.InnerBalanceClientApi = window.InnerBalanceClientApi || {};

        window.InnerBalanceClientApi.logEvent = ({ tag, data = {}, message }) => {
            logEvent({
                message,
                data,
                tag,
            });
        };

        window.InnerBalanceClientApi.sendGtmEvent = ({ event, data }) => {
            sendGtmEvent({
                event,
                value: data,
            });
        };

        window.InnerBalanceClientApi.sendWebEvent = ({
            event_name,
            event_type,
            widget,
            meta_data,
            href,
        }, callback) => {
            sendWebEvent(sendBigQueryEvent, {
                event_name,
                event_type,
                widget,
                meta_data,
                href,
            }, callback);
        };

        window.InnerBalanceClientApi.routerPush = (url) => {
            router.push(url);
        };
    }, [sendBigQueryEvent, logEvent, router]);

    return null;
};

export default ClientApiScript;
